import React, { useState, useEffect } from 'react';


const Bulmaspin = () => {
    return (<div class="card">
    <div class="card-content">
      <p class="title">
      “when you don't create things, you become defined by your tastes rather than ability. your tastes only narrow & exclude people. so create.”
      </p>
      <p class="subtitle">
      Why The Lucky Stiff
      </p>
    </div>
    
  </div>
  )
}

export default Bulmaspin;